<!-- Contains course card body {{Title,isbn,notes,suggestiontype}}-->
<template>
  <div class="card-body">
    <div v-if="adoptions && adoptions[0]?.bookId == null && flag != 2">

      <h4><i class="text-primary"> This course requires no textbooks but may require supplemental materials </i></h4>
      <div class="row" v-if="!toggleNotes">
      <div class="col-sm-2 pe-0 notelabel">
        <label class="fw-bold ">NOTES:&nbsp;</label>
      </div>
      <div class="col-sm-10 p-0 row" >
        <div class="col-sm-10">
        <p class="" v-if="adoptions[0].notes!=null && adoptions[0].notes!= '' && adoptions[0].notes!= undefined" v-html="adoptions[0].notes">
        </p>
        <p class="" v-else>Not available</p>
         </div>
      <div class="col-sm-2">
        <button type="button" class="btn-sm btn-outline-primary" @click="toggleNote()">
          <span class="material-icons-outlined btn-icon">edit_note</span>
          Edit Notes
        </button>
        
        </div>
      </div>
      </div>
      <div class="notes-card row" v-if="toggleNotes">
        <div class="col-sm-8"><form>
              <div class="form-group ">
                <label class="fw-bold ">NOTES:&nbsp;
                </label>
                <i>(Optional)</i>
                      <vue-editor v-model="initAdoptions[0].notes" :editorToolbar="customToolbar"></vue-editor>
                </div>
           </form>
        </div>
          <div class="col-sm-4 btn-notes"> 
             <button type="button" class="btn btn-primary float-centre me-2 " @click="updateAdoption(adoptions[0],initAdoptions[0].notes)">
                    <span class="material-icons-outlined btn-icon"> check_circle </span>
                   Update Notes
            </button>
           </div>
        </div>
      </div>
    
    <div v-else-if="adoptions && adoptions[0] && adoptions[0]?.bookId == null && flag == 2">
      <h5 class="message-adoption"><i> No previous adoptions!!</i></h5>
    </div>
    <div v-else>
      <ul class="list-group list-group-flush">
        <div class="accordion" id="accordionPanelsStayOpenExample">
          <div class="accordion-item item1" v-for="(adoption, index) in adoptions" :key="index" :value="adoption.id">

            <h2 class="accordion-header" id="panelsStayOpen-headingOne">
              
              <div class="row">
              <div class="col-sm-1 checkboxSelection" v-if="flag == 2">
                  <input class="form-check-input program_checkbox" type="checkbox" id="program9" v-model="adoption.isSelected"
                    @change="selectAdoption()">&nbsp;&nbsp;
              </div>
              <div class="col-sm-11 heading">
              <button class=" accordion-button collapsed button-element" type="button" data-bs-toggle="collapse"
                :data-bs-target="'#panelsStayOpen-body' + index + adoption.id" aria-expanded="true"
                aria-controls="panelsStayOpen-body">
                <span>{{ adoption.book ? adoption.book.isbn : '' }} {{ adoption.book ? adoption.book.title : '' }}
                  <span v-if="adoption.book && adoption.book.bookAuthors != null">by
                    <span v-for="(authors, index) in adoption.book.bookAuthors" :key="authors.id" :value="authors.id">
                      {{ authors.author.name }}
                      <span v-if="index != adoption.book.bookAuthors.length - 1">
                        /
                      </span>
                    </span>
                  </span>
                </span>
              </button>
            </div>
            </div>
         
            </h2>
            <div :id="'panelsStayOpen-body' + index + adoption.id" class="accordion-collapse collapse"
              aria-labelledby="panelsStayOpen-headingOne">
              <div class="accordion-body col-sm-12 row">
                <div class="
                  col-lg-2 col-md-12 col-sm-12 col-xs-12
                  text-center
                  align-middle
                ">
                  <img src="../../assets/imagenotfound.jpg" class="book-cover" />
                </div>
                <div class="col-sm-10">
                  <h4 class="text-primary">
                    {{ adoption.book ? adoption.book.title : '' }}
                  </h4>
                  <span v-if="adoption.book && adoption.book.bookAuthors != null">By
                    <span v-for="(authors, index) in adoption.book.bookAuthors" :key="authors.id" :value="authors.id">{{
                        authors.author.name
                    }}<span v-if="index != adoption.book.bookAuthors.length - 1">
                        /
                      </span>
                    </span>
                  </span>
                  <div class="flex-component-1">
                    <div class="form-group">
                      <label class="font-weight-bold">Edition:&nbsp;</label>
                      <span>{{ adoption.book ? adoption.book.edition : '' }}</span>
                    </div>
                    <div class="form-group">
                      <label class="font-weight-bold">Publisher:&nbsp;</label>
                      <span v-if="adoption.book && adoption.book.publisher != null">{{
                          adoption.book ? adoption.book.publisher : ''
                      }}</span>

                
                      <span v-else>Not Available </span>
                    </div>

                    <div class="row form">
                      <div class="col-sm-7 form-group">
                        <div class="">
                          <form>
                            <div class="mb-3">
                              <label for="exampleInputNotes" class="form-label"><b>Notes:</b><i>(Optional)</i></label>
                                <vue-editor v-model="adoption.notes" :editorToolbar="customToolbar"></vue-editor>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div class="col-sm-5 form-group suggestion-column">
                        <div class="card suggestion-card">
                          <p>This book is:</p>
                          <div class="form-check">
                            <input class="form-check-input" required type="radio" v-model="adoption.suggestion"
                              id="flexRadioDefault1" value=2 />
                            <label class="form-check-label" for="flexRadioDefault1">
                              Required
                            </label>
                          </div>

                          <div class="form-check">
                            <input class="form-check-input" required type="radio" id="flexRadioDefault2"
                              v-model="adoption.suggestion" value=1 />
                            <label class="form-check-label" for="flexRadioDefault2">
                              Recommended
                            </label>
                          </div>
                        </div>
                        <div class="btns-group">
                      <button v-if="flag == 0" type="button" class="btn btn-outline-danger me-2"
                        @click="removeAdoption(adoption.id)">
                        <span class="material-icons-outlined btn-icon">
                          delete
                        </span>
                        Remove TextBook
                      </button>
                      <button v-if="flag == 1" type="button" class="btn btn-primary me-2"
                        @click="$emit('useTheBook', adoption)">
                        <span class="material-icons-outlined btn-icon">
                          check_circle
                        </span>
                        Use this book
                      </button>
                      <button v-if="flag == 0" type="button" class="btn btn-primary" :class="{ 'me-2': flag != 0 }"
                        :disabled="(initAdoptions.length > 0 && adoption.notes == initAdoptions[index].notes && adoption.suggestion == initAdoptions[index].suggestion)"
                        @click="$emit('updateAdoption', adoption)">
                        <span class="material-icons btn-icon"> refresh </span>
                        Update
                      </button> 
                      <!-- <button v-if="flag == 0" type="button" class="btn btn-primary" :class="{ 'me-2': flag != 0 }"
                        @click="$emit('updateAdoption', adoption)">
                        <span class="material-icons btn-icon"> refresh </span>
                        Update
                      </button> -->
                    </div>

                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import courselistings from "../../assets/Courselists.json";
import { VueEditor } from "vue3-editor";
export default {
  components:{
    VueEditor
  },
  props: {
    adoptions: {
      bookId: '',
      id: '',
      book: {
        isbn: '',
        title: '',
        publisher: '',
        edition: '',
        bookAuthors: {
          name: '',
          authorId: ''
        }
      },
      suggestion: null,
      notes: '',
      
      
    },
    flag: Number,
  },
  emits: ['useTheBook', 'updateAdoption', 'removeAdoption', 'selectedAdoptions'],
  computed: {

  },
  methods: {
    removeAdoption(adoptionId) {
      this.$emit('removeAdoption', adoptionId);
    },
    selectAdoption() {
      this.$emit('selectedAdoptions', this.adoptions.filter(x => x.isSelected).map(x => x.id));
    },
    toggleNote(){
      this.toggleNotes=!this.toggleNotes
    },
    useTheBook(index) {
      let newAdoption =
      {
        sectionId: this.$parent.sectionId,
        adoptions: [
          {
            id: 0,
            bookId: this.adoptions[index].bookId,
            notes: this.adoptions[index].notes,
            suggestion: parseInt(this.adoptions[index].suggestion)
          }
        ]
      }
      this.$emit('useTheBook', newAdoption);
    },

    updateAdoption(adoption, notes = null) {
      console.log(adoption,"adoption")
      if(notes!=null){
      adoption.notes=notes;
      this.toggleNote();
      }
      let obj = {
        sectionId: adoption.sectionId,
        adoptions: [{ id: adoption.id, notes: adoption.notes, suggestion: parseInt(adoption.suggestion) }]
      }

      this.$store.dispatch("upsertAdoption", obj).then(() => {
        let _ = require('lodash');
        this.initAdoptions = _.cloneDeep(this.adoptions);
      })
    }
  },
  data() {
    return {
      courselistings,
      initAdoptions: [],
      i: 0,
      toggleNotes:false,
      customToolbar: [
        [{header: [false,1,2,3,4,5,6]}],
        [{
          align:""
        },
        {
          align:"center"
        },
        {
          align:"right"
        },
        {
          align:"justify"
        }],
        ["bold", "italic", "underline","link"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{indent:"-1"},{indent:"+1"}]
      ],
    };

  },
  mounted() {
    let _ = require('lodash');
    this.initAdoptions = _.cloneDeep(this.adoptions);
  }
};
</script>

<style scoped>
.suggestion-column{
  display: flex;
  flex-direction: column;
}
.book-cover {
  height: 150px !important;
  margin-top: 60px;
}

.suggestion-card {
  margin: 33px 0px 15px 0px;
  padding: 15px;
}

.notes-card {
  margin: 36px 0px 15px 0px;
  padding: 15px;
}
.btn-notes{
    vertical-align: revert;
    display: flex;
    align-items: end;
    justify-content: end
}
.btns-group{
  display: flex;
  margin-top: auto;
  justify-content: end;
}
.message-adoption {
  padding-left: 15px;
  color: #23f514;
}
.accordion-item {
  border: none;
}

.accordion-collapse.show {
  background-color: rgb(250 250 250);
  border: 1px solid #a0b2b2d6;
}
.checkboxSelection{
  padding: 0px;
  font-size: 25px;
  text-align: center;
  height: 25px;
  width:26px;
  margin-top: 8px;
  margin-right: 3px;
}
.notelabel{
  width:70px
}
.heading{
  padding: 0px;
  text-align: center;
}
</style>